// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Specular_Components_Common from "../Specular.Components.Common/index.js";
import * as Specular_Components_IconList from "../Specular.Components.IconList/index.js";
import * as Specular_Dom_Element from "../Specular.Dom.Element/index.js";
import * as Specular_Extra_Attr from "../Specular.Extra.Attr/index.js";
import * as Specular_FRP_Base from "../Specular.FRP.Base/index.js";
var attr = /* #__PURE__ */ Specular_Extra_Attr.attr(Specular_Extra_Attr.attrStringAttrs);
var element = /* #__PURE__ */ Specular_Components_Common.element();
var map = /* #__PURE__ */ Data_Functor.map(Specular_FRP_Base.functorDynamic);
var mempty = /* #__PURE__ */ Data_Monoid.mempty(Data_Monoid.monoidArray);
var pure = /* #__PURE__ */ Control_Applicative.pure(Specular_FRP_Base.applicativeDynamic);
var iconD = function (modifiers) {
    return function (icn) {
        var props = [ Specular_Dom_Element.class_("material-symbols-outlined"), Specular_Components_Common.unwrapModifier(Specular_Components_Common.attrsModifier(attr("aria-hidden")("true"))), Specular_Dom_Element.attr("translate")("no") ];
        return element("span")(props)(modifiers)(Specular_Dom_Element.dynText(map(Specular_Components_IconList.description)(icn)));
    };
};
var iconD_ = function (icn) {
    return iconD(mempty)(icn);
};
var icon = function (mods) {
    return function (icn) {
        return iconD(mods)(pure(icn));
    };
};
var icon_ = function (icn) {
    return icon(mempty)(icn);
};
export {
    icon,
    iconD,
    iconD_,
    icon_
};
export {
    MDIcon,
    add,
    addCircle,
    addCircleOutline,
    arrowBack,
    arrowDropDown,
    arrowRight,
    attachMoney,
    barChart,
    block,
    bookmark,
    build,
    call,
    campaign,
    cancel,
    check,
    checkCircleOutline,
    clear,
    close,
    closeFullscreen,
    code,
    contactSupport,
    contentCopy,
    createNewFolder,
    delete,
    description,
    divider,
    dividerSpecial,
    done,
    download,
    dragIndicator,
    edit,
    error,
    expandLess,
    expandMore,
    exportNotes,
    fill,
    filter,
    fullscreen,
    help,
    homePin,
    house,
    incompleteCircle,
    info,
    insertPhoto,
    lightbulb,
    localShipping,
    lockOpen,
    mail,
    md14,
    md18,
    md24,
    md36,
    md48,
    mobileOff,
    moped,
    moreVert,
    notifications,
    offlineBolt,
    openInFull,
    orderApprove,
    panTool,
    payments,
    person,
    pointOfSale,
    polyline,
    questionMark,
    rateReview,
    redo,
    refresh,
    remove,
    removeCircle,
    removeCircleOutline,
    removeShoppingCart,
    search,
    select,
    sell,
    separator,
    settings,
    shoppingBasket,
    shoppingCart,
    showChart,
    star,
    timerOff,
    undo,
    visibility,
    visibilityOff
} from "../Specular.Components.IconList/index.js";
